// @flow

import unifizeUser from "../index";
import ImageLabel from "src/components/user/ImageLabel/Medium";

export default unifizeUser(ImageLabel);
